import { create } from 'zustand';
import { extractForbiddenMessage } from '../helpers/http-error.helpers';

interface PermissionDeniedState {
  open: boolean;
  message: string;
  show: (message?: string) => void;
  showFromError: (error: unknown) => void;
  hide: () => void;
}

let lastShownAt = 0;
const DEDUPE_MS = 1200;

export const usePermissionDeniedStore = create<PermissionDeniedState>((set, get) => ({
  open: false,
  message: extractForbiddenMessage(null),

  show: (message) => {
    const now = Date.now();
    const nextMessage = message?.trim() || extractForbiddenMessage(null);
    if (get().open && get().message === nextMessage && now - lastShownAt < DEDUPE_MS) {
      return;
    }
    lastShownAt = now;
    set({ open: true, message: nextMessage });
  },

  showFromError: (error) => {
    get().show(extractForbiddenMessage(error));
  },

  hide: () => {
    set({ open: false });
  },
}));

export function showPermissionDenied(message?: string): void {
  usePermissionDeniedStore.getState().show(message);
}

export function showPermissionDeniedFromError(error: unknown): void {
  usePermissionDeniedStore.getState().showFromError(error);
}
